import React, { useState } from 'react';
import { Container, Form, Button, Card, Alert } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [ssoLoading, setSsoLoading] = useState(false);
  const { login, ssoLogin } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(username, password);
      navigate('/products');
    } catch (err) {
      setError(err.response?.data?.error || t('auth.loginFailed'));
    } finally {
      setLoading(false);
    }
  };

  const handleSsoLogin = async () => {
    setError('');
    setSsoLoading(true);

    try {
      await ssoLogin();
      navigate('/products');
    } catch (err) {
      setError(err.response?.data?.error || t('auth.ssoFailed'));
    } finally {
      setSsoLoading(false);
    }
  };

  return (
    <Container className="py-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <Card>
            <Card.Body>
              <h2 className="text-center mb-4">{t('auth.loginTitle')}</h2>
              
              {error && <Alert variant="danger">{error}</Alert>}
              
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>{t('auth.username')}</Form.Label>
                  <Form.Control
                    type="text"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>{t('auth.password')}</Form.Label>
                  <Form.Control
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </Form.Group>

                <Button 
                  type="submit" 
                  variant="primary" 
                  className="w-100"
                  disabled={loading}
                >
                  {loading ? t('common.loading') : t('auth.login')}
                </Button>

                <div className="text-center mt-2">
                  <Link to="/forgot-password" className="text-muted small">
                    {t('auth.forgotPassword')}
                  </Link>
                </div>
              </Form>

              <div className="text-center my-3 text-muted">{t('auth.or')}</div>

              <Button
                variant="outline-dark"
                className="w-100"
                onClick={handleSsoLogin}
                disabled={ssoLoading}
              >
                {ssoLoading ? t('common.loading') : t('auth.continueGoogle')}
              </Button>

              <div className="text-center mt-3 text-muted">
                {t('auth.contactAdminForAccess')}
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </Container>
  );
};

export default Login;
